"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var checkbox_group_1 = require("msteams-ui-styles-core/lib/components/checkbox-group");

var PropTypes = require("prop-types");

var React = require("react");

var teams_context_1 = require("../teams-context");

var add_1 = require("../utils/add");

var classes_1 = require("../utils/classes");

var remove_1 = require("../utils/remove");

var uniqueId_1 = require("../utils/uniqueId");

var CheckboxGroupInner =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CheckboxGroupInner, _React$Component);

  function CheckboxGroupInner() {
    var _this;

    _classCallCheck(this, CheckboxGroupInner);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CheckboxGroupInner).apply(this, arguments));
    _this.state = {
      labelId: uniqueId_1.default('ts-rgl'),
      groupId: uniqueId_1.default('ts-cg-')
    };

    _this.handleChange = function (checked, value) {
      if (_this.props.onChecked) {
        var values = Array.isArray(_this.props.values) ? _this.props.values : [];
        values = checked ? add_1.default(values, value) : remove_1.default(values, value);

        _this.props.onChecked(values);
      }
    };

    return _this;
  }

  _createClass(CheckboxGroupInner, [{
    key: "render",
    value: function render() {
      var _a = this.props,
          context = _a.context,
          className = _a.className,
          onChecked = _a.onChecked,
          values = _a.values,
          label = _a.label,
          errorLabel = _a.errorLabel,
          children = _a.children,
          rest = __rest(_a, ["context", "className", "onChecked", "values", "label", "errorLabel", "children"]);

      var themeClassNames = checkbox_group_1.checkboxGroup(context);
      var actualId = this.state.groupId;
      var hasLabel = !!label;
      var hasError = !!errorLabel;
      return React.createElement("div", Object.assign({}, rest), React.createElement("label", {
        id: this.state.labelId,
        "aria-live": "polite"
      }, hasLabel ? React.createElement("span", {
        className: themeClassNames.label
      }, label) : null, hasError ? React.createElement("span", {
        className: themeClassNames.errorLabel
      }, errorLabel) : null), React.createElement("div", {
        id: actualId,
        role: "group",
        "aria-labelledby": this.state.labelId,
        className: classes_1.default(themeClassNames.container, className),
        "aria-invalid": hasError
      }, children));
    } // tslint:disable-next-line:no-unused-variable

  }, {
    key: "getChildContext",
    value: function getChildContext() {
      return {
        onChecked: this.handleChange,
        values: this.props.values
      };
    }
  }]);

  return CheckboxGroupInner;
}(React.Component);

CheckboxGroupInner.childContextTypes = {
  onChecked: PropTypes.func,
  values: PropTypes.array
};
CheckboxGroupInner.propTypes = {
  onChecked: PropTypes.func,
  values: PropTypes.array
};
exports.CheckboxGroup = teams_context_1.connectTeamsComponent(CheckboxGroupInner);